var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"wrapper",attrs:{"fluid":""}},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"sm":"4"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }